var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        ("" + _vm.classPrefix),
        _vm.theme && (_vm.classPrefix + "--" + _vm.theme),
        _vm.mode && (_vm.classPrefix + "--" + _vm.mode),
        _vm.collapse && _vm.mode === 'vertical' && (_vm.classPrefix + "--collapse") ],style:(_vm.menuStyle)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }